exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: relative;\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  min-height: 100vh;\n  width: 100%; }\n\n.modal-body {\n  padding: 1rem 1.5rem; }\n  .modal-body .inner-content {\n    position: relative;\n    min-height: 50rem;\n    padding-bottom: 4rem; }\n    .modal-body .inner-content .body-footer {\n      position: absolute;\n      bottom: 1rem;\n      left: 15px; }\n  @media (max-width: 576px) {\n    .modal-body {\n      min-height: 40rem; } }\n\n.error {\n  color: #ff0000; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/auth/login/login.component.scss
// module id = ../../../../../src/app/auth/login/login.component.scss
// module chunks = 2